import { FaCheckCircle } from "react-icons/fa";

import LayoutCard from "~/components/LayoutCard";
import { SecondaryLayout } from "~/layouts";
import type { NextPageWithProps } from "~/types";

const EmailVerificationSuccessPage: NextPageWithProps = () => {
	return (
		<LayoutCard
			title="Email Verification Successful"
			subtitle="You can now close this tab."
			className="flex flex-col items-center"
			button={{
				direction: "right",
				label: "Dashboard",
				href: "/learning-plan",
			}}
		>
			<FaCheckCircle size={100} className="my-8 text-emerald-500" />
		</LayoutCard>
	);
};

EmailVerificationSuccessPage.Layout = SecondaryLayout;

export default EmailVerificationSuccessPage;
